import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Reactions';

const ReactionApi: any = baseApi(endpoint);

export default ReactionApi;